import React, { useState } from 'react'
import styled from 'styled-components'
import { Link } from 'gatsby'

import { Heading2, Paragraph } from '../../styles/Text'

const Heading = styled(Heading2)`
  margin-bottom: 32px;
`

const ItemsRow = styled.div`
  display: flex;
  column-gap: 16px;
  :not(:last-child) {
    margin-bottom: 48px;
  }
`

const Item = styled.div`
  width: 100%;
`

const Icon = styled.div`
  width: 64px;
  margin-bottom: 16px;
  min-height: 64px;
  img {
    width: 100%;
  }
`

const ItemHeading = styled.div`
  margin-bottom: 16px;
  font-weight: 500;
  font-size: 20px;
  line-height: 170%;
`

const ItemText = styled(Paragraph)`
  a {
    font-weight: 600;
    text-decoration: underline;
  }
`

const SelectItemsWrapper = styled.div`
  display: flex;
  column-gap: 72px;
`

const Left = styled.div`
  width: 50%;
`

const Right = styled.div`
  width: 50%;
  img {
    width: 100%;
  }
`

const SelectItem = styled.button`
  display: flex;
  align-items: center;
  padding: 10px 16px;
  text-align: left;
  border-radius: 4px;
  ${(p) => p.selected && 'background-color:#E6E2FC;'}
  img {
    width: 34px;
    height: 34px;
    margin-right: 24px;
    flex-shrink: 0;
  }
  :not(:last-child) {
    margin-bottom: 8px;
  }
`

const TextIconAndImages = () => {
  const [selectedItem, setSelectedItem] = useState(0)
  return (
    <>
      <Heading>Text, icon and images</Heading>
      <ItemsRow>
        <Item>
          <Icon>
            <img src="/images/icon-chat.svg" alt="" />
          </Icon>
          <ItemHeading>Heading</ItemHeading>
          <ItemText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut{' '}
            <Link to="/chameleon">labore et dolore</Link> magna aliqua commodo consequat.
          </ItemText>
        </Item>
        <Item>
          <Icon>
            <img src="/images/icon-feeds.svg" alt="" />
          </Icon>
          <ItemHeading>Heading</ItemHeading>
          <ItemText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut{' '}
            <Link to="/chameleon">labore et dolore</Link> magna aliqua commodo consequat.
          </ItemText>
        </Item>
      </ItemsRow>
      <ItemsRow>
        <Item>
          <Icon>
            <img src="/images/icon-presence.svg" alt="" />
          </Icon>
          <ItemHeading>Heading</ItemHeading>
          <ItemText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut{' '}
            <Link to="/chameleon">labore et dolore</Link> magna aliqua commodo consequat.
          </ItemText>
        </Item>
        <Item>
          <Icon>
            <img src="/images/icon-qas.svg" alt="" />
          </Icon>
          <ItemHeading>Heading</ItemHeading>
          <ItemText>
            Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut{' '}
            <Link to="/chameleon">labore et dolore</Link> magna aliqua commodo consequat.
          </ItemText>
        </Item>
      </ItemsRow>
      <SelectItemsWrapper>
        <Left>
          <SelectItem onClick={() => setSelectedItem(0)} selected={selectedItem === 0}>
            <img src="/images/icon-chat.svg" alt="" />
            <Paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et{' '}
            </Paragraph>
          </SelectItem>
          <SelectItem onClick={() => setSelectedItem(1)} selected={selectedItem === 1}>
            <img src="/images/icon-feeds.svg" alt="" />
            <Paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et{' '}
            </Paragraph>
          </SelectItem>
          <SelectItem onClick={() => setSelectedItem(2)} selected={selectedItem === 2}>
            <img src="/images/icon-presence.svg" alt="" />
            <Paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et{' '}
            </Paragraph>
          </SelectItem>
          <SelectItem onClick={() => setSelectedItem(3)} selected={selectedItem === 3}>
            <img src="/images/icon-qas.svg" alt="" />
            <Paragraph>
              Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et{' '}
            </Paragraph>
          </SelectItem>
        </Left>
        <Right>
          {selectedItem === 0 && <img src="/images/chameleon/fixed-aspect-ratio-spacer.png" alt="" />}
          {selectedItem === 1 && <img src="/images/chameleon/fixed-aspect-ratio-spacer.png" alt="" />}
          {selectedItem === 2 && <img src="/images/chameleon/fixed-aspect-ratio-spacer.png" alt="" />}
          {selectedItem === 3 && <img src="/images/chameleon/fixed-aspect-ratio-spacer.png" alt="" />}
        </Right>
      </SelectItemsWrapper>
    </>
  )
}

export default TextIconAndImages
